import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

interface SendToDriverModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSend: (driverId: number) => void;
  loading?: boolean;
}

const SendToDriverModal: React.FC<SendToDriverModalProps> = ({
  isOpen,
  onClose,
  onSend,
  loading = false
}) => {
  const { t } = useTranslation();
  const [driverId, setDriverId] = useState<string>('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (driverId && !isNaN(parseInt(driverId))) {
      onSend(parseInt(driverId));
    }
  };

  const handleClose = () => {
    setDriverId('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title={t('modals.sendToDriver.title')}>
      <form onSubmit={handleSubmit} className="modal-form">
        <div className="modal-form-group">
          <label htmlFor="driverId">{t('modals.sendToDriver.driverIdLabel')}</label>
          <input
            type="number"
            id="driverId"
            value={driverId}
            onChange={(e) => setDriverId(e.target.value)}
            placeholder={t('modals.sendToDriver.driverIdPlaceholder')}
            required
            disabled={loading}
            min="1"
          />
        </div>

        <div className="modal-actions">
          <button
            type="button"
            onClick={handleClose}
            className="modal-button secondary"
            disabled={loading}
          >
            {t('modals.sendToDriver.cancel')}
          </button>
          <button
            type="submit"
            className="modal-button primary"
            disabled={loading || !driverId || isNaN(parseInt(driverId))}
          >
            {loading ? t('modals.sendToDriver.sending') : t('modals.sendToDriver.send')}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default SendToDriverModal;
